<template>
	<div class="TeacherDetail">
		<Header></Header>
		<div class="tebg" style='background: #101218;'>
			<img :src="oonfooData.cover" alt="" style="width: 200px;
    height: 200px;
    margin: 0 auto;
    display: block;" width="100%" height="250px">
		</div>
		<div class="tename">
			<p>{{oonfooData.name}}</p>
			<p>{{oonfooData.title}}</p>
		</div>
		<div class="teline"></div>
		<div class="tetext">
			<p v-html="oonfooData.description">
			
			</p>
		</div>
		<div class="nextBtn w95">
			<p @click="upArticle(upid)">上一位</p>
			<div class="boxs"></div>
			<p @click="downArticle(downid)">下一位</p>
		</div>
		<Fotter></Fotter>
	</div>
</template>

<script>
	import Header from "./Header.vue";
	import Fotter from "./Fotter.vue";
		import __Config from '../api/config';
	
	export default {
		name: 'TeacherDetail',
		components: {
			Header,
			Fotter
		},
		data() {
			return {
               id:this.$route.params.id,
			   oonfooData:[],
			 
			   upid:{},
			   downid:{},
			}

		},
		methods: {
			getDetailinfo(){
						var that = this;
						this.$axios.get(__Config.api.getwebTeacherInfo+ this.id,{
							
						})
						.then(function (res) {
							that.oonfooData= res.data.data;
							that.upid = res.data.data.upId;
						
							that.downid = res.data.data.nextId;
						
						})
						.catch(function (err) {
							console.log(err);
						});
				},
				upArticle(id){
				  if(id==0){
                       this.$notify({ type: 'danger', message: '没有上一位' });
				  }else{
                      this.id = this.upid;
					 this.getDetailinfo();
				     console.log(id)
				  }
					
			
				},
				downArticle(id){
				 if(id==0){
                       this.$notify({ type: 'danger', message: '没有下一位' });
				  }else{
                    this.id = this.downid;
					this.getDetailinfo();
				  }

			}
				},
				created(){
					this.getDetailinfo();
				}
	}
</script>

<style scoped>
	.tename p {
		text-align: center;
		margin: 13px;
		color: #333;
	}

	.tename p:nth-child(1) {
		color: #000;
		font-weight: bold;
	}

	.teline {
		width: 95%;
		height: 1px;
		background: #ccc;
		margin: 0 auto;
	}

	.tetext p {
		margin: 13px;
		font-size: 14px;
		color: #333;
		line-height: 20px;
	}
	
	/**/
	.nextBtn{
		margin: 20px auto;
		display: flex;
		text-align: center;
		line-height: 35px;
	}
	.boxs{
		width: 20px;
	}
	.nextBtn p{
		color: #007CCF;
		flex: 1;
		border:2px solid rgba(0,124,207,1);
		border-radius:25px;
	}
</style>



// WEBPACK FOOTER //
// src/components/TeacherDetail.vue